// extracted by mini-css-extract-plugin
module.exports = {"border-stroke":"ApiKeyModal_border-stroke___Pt_k","legend-title":"ApiKeyModal_legend-title__KqOzx","apikey-font":"ApiKeyModal_apikey-font___FgTS"};